import axios from 'axios';
import { initAxios } from 'utils/axiosHelper';
import type {
  ColumnMappingPlan,
  ColumnMappingRequest,
} from 'pages/import/lib/import-mapping';

// Import Hub "Use your template" column mapping is served by PyAPI (FastAPI)
// at /pyapi/import-hub/column-mapping. initAxios attaches the Keycloak bearer
// token, which PyAPI verifies against the request's group_id.
// eslint-disable-next-line no-undef
const PYAPI_BASE_URL = process.env.REACT_APP_PYAPI_URL || '/pyapi';
const apiClient = initAxios(PYAPI_BASE_URL);

// pyapi caps the whole mapping call at 55s (QA/prod sit behind a load
// balancer with a 60s idle timeout); leave headroom for the deterministic pass
// and the network before the dialog falls back to exact header matching.
const COLUMN_MAPPING_TIMEOUT_MS = 60 * 1000;

const getErrorMessage = (error: unknown, fallback: string): string => {
  if (!axios.isAxiosError(error)) {
    return error instanceof Error ? error.message : fallback;
  }
  const data = error.response?.data as any;
  const upstreamMessage =
    (typeof data?.message === 'string' && data.message) ||
    (typeof data?.error === 'string' && data.error) ||
    (typeof data?.detail === 'string' && data.detail) ||
    '';
  return upstreamMessage || fallback;
};

export class ImportMappingAPI {
  static async suggestColumnMapping(
    profile: ColumnMappingRequest,
    signal?: AbortSignal,
  ): Promise<ColumnMappingPlan> {
    try {
      const response = await apiClient.post(
        '/import-hub/column-mapping',
        profile,
        { timeout: COLUMN_MAPPING_TIMEOUT_MS, signal: signal },
      );
      return response.data;
    } catch (error) {
      throw new Error(getErrorMessage(error, 'Failed to match columns.'));
    }
  }
}

export default ImportMappingAPI;
